module.exports = __webpack_public_path__ + "static/media/cullen_vamp.8fd74556.png";